import { IApplicationState } from '../../types/redux';

export const selectIsModalRemoveOpen = (state: IApplicationState) => state.folders.modalRemoveIsOpen;
